import config from '@/services/config';
import axios from 'axios';

const servicio = {};
const url = config.apiUrl

servicio.validarNombreUsuario = (usuario) => {
    return axios.post(`${url}/seguridad/verificar-nombre-usuario`, {IdUsuario:usuario})
    .then(r => {
        return r.data
    })
    .catch(error => {
        console.error(error)
    })
}

servicio.login = (usuario, password) => {
    return axios.post(`${url}/seguridad/login`, {usuario, password})
        .then(r => {
            return r.data
        })
        .catch(error => {
            console.error(error)
        })
}

servicio.loginTk = (tk) => {
    return axios.post(`${url}/seguridad/login-tk`, {tk})
        .then(r => {
            return r.data
        })
        .catch(error => {
            console.error(error)
        })
}

servicio.recuperarPasswordCorreo = (usuario) => {
    return axios.post(`${url}/seguridad/recuperar-password-correo`, {IdUsuario:usuario})
        .then(r => {
            return r.data
        })
        .catch(error => {
            console.error(error)
        })
}

servicio.recuperarPasswordVerificar = (ref) => {
    return axios.post(`${url}/seguridad/recuperar-password-verificar`, {referencia:ref})
        .then(r => {
            return r.data
        })
        .catch(error => {
            console.error(error)
        })
}

servicio.recuperarPasswordRestablecer = (ref, password) => {
    return axios.post(`${url}/seguridad/recuperar-password-restablecer`, {referencia:ref, password:password})
        .then(r => {
            return r.data
        })
        .catch(error => {
            console.error(error)
        })
}

servicio.contacto = (nombre, email, telefono, mensaje, ciudad, estado) => {
    return axios.post(`${url}/publico/solicitud-contacto/enviar`, {nombre, email, telefono, mensaje, ciudad, estado})
        .then(r => {
            return r.data
        })
        .catch(error => {
            console.error(error)
        })
}

servicio.estadosRepublica = () => {
    return axios.get(`${url}/catalogos/estados`)
        .then(r => {
            return r.data
        })
        .catch(error => {
            console.error(error)
        })
}

servicio.colaboremos = (nombre, telefono, correo, negocio, municipio, codestado) => {
    return axios.post(`${url}/publico/colaboremos/enviar`, {nombre, telefono, correo, negocio, municipio, codestado})
        .then(r => {
            return r.data
        })
        .catch(error => {
            console.error(error)
        })
}

servicio.consultarBannerComercialLogo = () => {
    return axios.get(`${url}/publico/inicio/consultar-banner-comercial-logo`)
        .then(r => {
            return r.data
        })
        .catch(err => {
            console.log(err)
        })
}

servicio.descargarCartaPorte = ( parametro ) => {
    return axios.post(`${url}/publico/descargar-carta`, parametro)
        .then(r => {
            return r.data
        })
        .catch(error => {
            console.error(error)
        })
}

servicio.descargarCartaPorteId = ( parametro ) => {
    return axios.post(`${url}/publico/descargar-carta-id`, parametro)
        .then(r => {
            return r.data
        })
        .catch(error => {
            console.error(error)
        })
}

export default servicio;
